/**
 * Base64 for any Unicode text. `btoa` alone throws `InvalidCharacterError` on characters outside
 * Latin-1 (smart quotes, em dashes, ellipses pasted from Word or Outlook), so the text is encoded
 * to its UTF-8 bytes first.
 */
export const encodeBase64Utf8 = (text: string): string => {
  let binary = '';
  // A loop instead of spreading the bytes into fromCharCode: a long note would exceed the
  // maximum number of call arguments.
  new TextEncoder().encode(text).forEach((byte) => (binary += String.fromCharCode(byte)));
  return btoa(binary);
};

/**
 * Reverses encodeBase64Utf8. Values written before it existed were plain `btoa(text)`: ASCII text
 * decodes the same either way, and Latin-1 text that is not valid UTF-8 is returned as before.
 */
export const decodeBase64Utf8 = (encoded: string): string => {
  const binary = atob(encoded);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
  } catch {
    return binary;
  }
};
